export default __webpack_public_path__ + "static/icon-pubertad-act-f60e51eb545a838e49bec70ccf5d460a.png";